import { getAbTestV2 } from 'dibs-buyer-layout/exports/clientABTestV2';

export const SALE_TEST_NAME = 'Homepage_SaleModule_June2025';

export const isSaleVariant = (): boolean => getAbTestV2(SALE_TEST_NAME)?.variant === 'variant';
